import React, { useEffect, useState } from "react";
import { Tooltip } from "antd";
import { Error, Success } from "../../../../commons/Messages/Messages";
import axios from "axios";
import DeleteModal from "../../../../commons/DeleteModal/DeleteModal";
import AddShifts from "./AddShifts";
import UpdateShift from "./UpdateShifts";
import DropdownComp from "../../../../commons/Dropdowns/DropdownComp";
import { generalErrorAlert } from "../../../../commons/GeneralErrorAlert";
import GeneralTable from "../../../../commons/GeneralTable";
import dayjs from "dayjs";
import { isAuthenticated } from "../../../../commons/Auth/auth";
import PageToolbar from "../../../../design-system/PageToolbar";

import { useTranslation } from "react-i18next";
const Shifts = () => {
  const { t } = useTranslation("dashboard");
  const [shiftsArray, setShiftsArray] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(20);
  const [loading, setLoading] = useState(false);
  const [totalCount] = useState(0);
  const [employees, setEmployees] = useState([]);

  const getEmployees = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/employees/employee/creator/${isAuthenticated()?.serviceProviderId}`,
        { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
      );
      if (Array.isArray(res.data)) setEmployees(res.data);
    } catch (err) {
      generalErrorAlert(err);
    }
  };

  const getData = async () => {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/shifts`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        setLoading(false);
        if (res.status === 200 || res.status === 304) {
          setShiftsArray(res.data);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        setLoading(false);
        generalErrorAlert(err);
      });
  };

  const deleteHandler = async id => {
    await axios
      .delete(`${process.env.REACT_APP_BACKEND_URL}/shifts/delete/${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          getData();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        generalErrorAlert(err);
      });
  };

  useEffect(() => {
    getData();
    getEmployees();

    return () => {};
  }, []);

  const columns = [
    {
      title: "#",
      dataIndex: "_id",
      mobile: "hidden",
      render: (text, record, index) => index + 1,
      sorter: (a, b) => a._id.length - b._id.length
    },
    {
      title: t("Title"),
      dataIndex: "title",
      width: "30%",
      mobile: "title",
      sorter: (a, b) => a.title?.localeCompare(b?.title),
      render: text => (
        <Tooltip title={text}>
          <span
            style={{
              display: "inline-block",
              maxWidth: "min(200px, 100%)",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
          >
            {text}
          </span>
        </Tooltip>
      )
    },
    {
      title: t("Start Time"),
      dataIndex: "start",
      render: text => dayjs(text).format("DD/MMM/YYYY") || "N/A"
    },
    {
      title: t("End Time"),
      dataIndex: "end",
      render: text => dayjs(text).format("DD/MMM/YYYY") || "N/A"
    },
    {
      title: t("Color"),
      dataIndex: "color",
      render: (text, obj) => (
        <div
          style={{
            width: "20px",
            height: "20px",
            backgroundColor: obj?.color,
            borderRadius: "50%"
          }}
        >
          {/* <Badge style={{}} key={obj?.color} color={obj?.color} /> */}
        </div>
      )
    },
    {
      title: t("Action"),
      key: "action",
      mobile: "actions",
      render: (text, obj) => {
        const menuItems = [
          {
            key: "edit",
            component: () => <UpdateShift data={obj} employees={employees} updateParent={getData} />
          },
          {
            key: "delete",
            component: () => <DeleteModal text="Shift" onClick={() => deleteHandler(obj?._id)} />
          }
        ];
        return (
          <div>
            <DropdownComp menuItems={menuItems} />
          </div>
        );
      }
    }
  ];

  return (
    <>
      <PageToolbar actions={<AddShifts updateParent={getData} employees={employees} />} />
      <GeneralTable
        data={shiftsArray}
        loading={loading}
        columns={columns}
        pagination={false}
        rowKey={record => record._id}
        pageNo={pageNo}
        pageSize={pageSize}
        totalCount={totalCount}
        setPageNo={setPageNo}
      />
    </>
  );
};

export default Shifts;
